import type { Mission } from '@/features/missions/types/mission'

export type MissionLockState =
  | { kind: 'ready' }
  | { kind: 'locked'; hint: string }

const FALLBACK_HINT = 'Missão bloqueada'

/**
 * Traduz o payload da missão no estado que o card renderiza.
 *
 * A decisão de bloqueio é sempre do backend (`locked`) — o front nunca a
 * recalcula, porque não recebe os dados da regra. O `unlock_hint` também vem
 * pronto; aqui só há fallback para o caso de ele faltar.
 */
export function getMissionLockState(mission: Mission): MissionLockState {
  if (!mission.locked) return { kind: 'ready' }

  const hint = mission.unlock_hint?.trim()

  return { kind: 'locked', hint: hint || FALLBACK_HINT }
}
